import { render, staticRenderFns } from "./_live22.vue?vue&type=template&id=ff0d3c84&lang=pug&"
import script from "./_live22.vue?vue&type=script&lang=js&"
export * from "./_live22.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports